import { IconProps } from '../types';

export const DownloadIcon = (props: IconProps): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
      <path
        fill="#768EA7"
        d="M10.833 1.667a.833.833 0 0 0-1.667 0v9.655l-1.91-1.91a.833.833 0 1 0-1.18 1.178l3.333 3.333a.832.832 0 0 0 .587.245h.006a.831.831 0 0 0 .587-.245l3.333-3.333a.833.833 0 1 0-1.179-1.179l-1.91 1.911V1.667Z"
      />
      <path
        fill="#768EA7"
        d="M2.5 13.334c.46 0 .833.373.833.833v2.5c0 .46.373.834.833.834h11.667c.46 0 .833-.373.833-.834v-2.5a.833.833 0 0 1 1.667 0v2.5a2.5 2.5 0 0 1-2.5 2.5H4.166a2.5 2.5 0 0 1-2.5-2.5v-2.5c0-.46.373-.833.833-.833Z"
      />
    </svg>
  );
};
